if (!customElements.get("stmt-video-scroll")) {
  class VideoScroll extends HTMLElement {
    constructor() {
      super();

      this.header = document.querySelector(".js-site-header");

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      this.isTouch = window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;
      this.sectionEl = this.closest(".js-video-scroll");
      this.video = this.querySelector(`.js-video${this.isTouch ? "-mobile" : ""}`);

      if (!this.video) return;

      this.scrollTop = window.scrollY - this.sectionEl.offsetTop;
      this.scrollDistance = this.offsetHeight - this.video.offsetHeight - this.header.offsetHeight;
      this.seeking = false;
      this.webmSrc = this.video.dataset.webm;
      this.movSrc = this.video.dataset.mov;
    }

    connectedCallback() {
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.setVideoUrl(entry.target);

            observer.unobserve(this.video);
          }
        });
      });

      if (this.video) {
        this.video.addEventListener("loadeddata", () => this.loadVideo());

        observer.observe(this.video);
      }
    }


    setVideoUrl() {
      if(this.supportsHEVCAlpha() === false && this.iOS() === true) {
        this.video.src = this.webmSrc;
      } else if(this.supportsHEVCAlpha() === false && this.iOS() === false) {
        this.video.src = this.webmSrc;
      } else {
        this.video.src = this.movSrc;
      }
    }

    loadVideo() {
      this.video.pause();
      this.playVideo();

      window.addEventListener("scroll", () => this.playVideo());

      this.video.addEventListener("seeking", () => this.seeking = true);
      this.video.addEventListener("seeked", () => this.seeking = false);
    }

    playVideo() {
      const scrollTop = window.scrollY - this.sectionEl.offsetTop;

      let percentage = scrollTop / this.scrollDistance;

      percentage = Math.max(0, percentage);
      percentage = Math.min(percentage, 1);

      const currentTime = percentage * this.video.duration;

      if (this.video.duration > 0 && scrollTop <= this.scrollDistance && !this.seeking) {
        this.video.currentTime = currentTime;
      }
    }

    supportsHEVCAlpha() {
      const navigator = window.navigator;
      const ua = navigator.userAgent.toLowerCase()
      const hasMediaCapabilities = !!(navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo)
      const isSafari = ((ua.indexOf('safari') !== -1)&& (!(ua.indexOf('chrome') !== -1) && (ua.indexOf('version/') !== -1)))

      return isSafari && hasMediaCapabilities
    }

    iOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
  }

  customElements.define("stmt-video-scroll", VideoScroll);
}